import { __decorate, __metadata } from 'tslib';
import { ControllerRegistry } from '../../registries/controller-registry.js';
import { Service } from '../../decorators/class/service.js';
import { ServiceCollection } from '../service-collection.js';
import { BuiltinUiState } from '../store/builtin-state.js';
import { StateManager } from '../store/state-manager.js';
import SchematicUIService from '../../controllers/base/schematic-ui-service.js';
import { ITEM_NAME_TO_SERVICE_NAME } from '../../constants/ui-service-item-name.js';

/**
 * controller级别功能配置服务
 * @public
 */
let ConfigControllerService = class ConfigControllerService {
    constructor(serviceCollection, store) {
        this.serviceCollection = serviceCollection;
        this.store = store;
        // controller级别开关
        this.disabledController = new Set();
        this.store.register(BuiltinUiState.ControllerStatus, this.disabledController);
    }
    /**
     * 设置controller开关，被关闭的不会被点击
     */
    disableController(name) {
        this.disabledController.add(name);
        this.store.update(BuiltinUiState.ControllerStatus, this.disabledController);
        this.updateUIService(name);
    }
    /**
     * 设置controller开关，被关闭的不会被点击
     */
    enableController(name) {
        this.disabledController.delete(name);
        this.store.update(BuiltinUiState.ControllerStatus, this.disabledController);
        this.updateUIService(name);
    }
    updateUIService(name) {
        const services = this.getUIServiceToBeUpdate(name);
        services.forEach((serviceName) => {
            const service = this.serviceCollection.getControllerRelatedUIServices().get(serviceName);
            if (service instanceof SchematicUIService) {
                service.update();
            }
        });
    }
    /**
     * 获取controller影响的ui service名称
     */
    getUIServiceToBeUpdate(name) {
        const iter = ControllerRegistry.values();
        let result = iter.next();
        const uiServices = [];
        while (!result.done) {
            if (result.value.name === name || result.value.provide.name === name) {
                Object.keys(result.value).forEach((key) => {
                    const serviceName = ITEM_NAME_TO_SERVICE_NAME[key];
                    uiServices.push(serviceName);
                });
                // 从ControllerRegistry找到对应name的controller就不再遍历
                break;
            }
            result = iter.next();
        }
        return uiServices;
    }
};
ConfigControllerService = __decorate([
    Service({ overridable: true }),
    __metadata("design:paramtypes", [ServiceCollection,
        StateManager])
], ConfigControllerService);

export { ConfigControllerService };
//# sourceMappingURL=config-controller-service.js.map
